/* import __COLOCATED_TEMPLATE__ from './beta-badge-filled.hbs.js'; */
var _dec, _dec2, _dec3, _class;
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
import { computed } from '@ember/object';
import SvgIcon from '@square/glass-ui/components/svg/svg-icon';
import { getVerticalColor } from '@dashboard/shared-ui/utils/verticals';
import Enum from '@square/dashboard-utilities/utils/enum';

/**
##Svgs::BetaBadgeFilled

Displays an SVG of the word BETA on a solid background color.

### Params
@param {String} vertical - The vertical that is using the BETA badge. This configures the background color.
                           Verticals are defined in @dashboard/shared-ui/utils/vertical-configs.

### Example usages
hbs```
  <Svgs::BetaBadgeFilled @vertical={{Vertical.RESTAURANTS}} />
```

hbs```
  <Svgs::BetaBadgeFilled @theme={{BANNER_THEMES.INVERTED_TEAL_BACKGROUND}} @vertical={{Vertical.RETAIL}} />
```
 */

export const BANNER_THEMES = new Enum('INVERTED_TEAL_BACKGROUND', 'INVERTED');
let BetaBadgeFilled = (_dec = computed('theme', 'vertical'), _dec2 = computed('themeColors.defaultColor', 'vertical'), _dec3 = computed('themeColors.accentColor'), _class = class BetaBadgeFilled extends SvgIcon {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "width", 43);
    _defineProperty(this, "height", 24);
    _defineProperty(this, "viewBox", '0 0 43 24');
    _defineProperty(this, "fill", 'none');
    // Inherited from SvgIcon base class, this adds a class that interferes with
    // SVG styling
    _defineProperty(this, "colorClass", null);
  }
  get themeColors() {
    if (this.theme === BANNER_THEMES.INVERTED_TEAL_BACKGROUND) {
      return {
        accentColor: '#c4f5f0',
        defaultColor: getVerticalColor(this.vertical)
      };
    } else if (this.theme === BANNER_THEMES.INVERTED) {
      return {
        accentColor: getVerticalColor(this.vertical),
        defaultColor: '#fff'
      };
    }
    return {};
  }
  get defaultColor() {
    return this.themeColors.defaultColor || getVerticalColor(this.vertical);
  }
  get accentColor() {
    return this.themeColors.accentColor || '#fff';
  }
}, _applyDecoratedDescriptor(_class.prototype, "themeColors", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "themeColors"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "defaultColor", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "defaultColor"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "accentColor", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "accentColor"), _class.prototype), _class);
export { BetaBadgeFilled as default };